import * as React from 'react';

const Logo = ({ className = '' }: { className?: string }): JSX.Element => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 244.789 87.363">
		<g fill="#f26522">
			<path d="m149.12 87.363 12.811-32.859h-25.687Z" />
			<path d="M131.419 42.172h35.319l10.032-25.718L148.88 0l-27.6 16.294Z" />
			<path d="m189.151 25.575-6.853 16.6h6.853Z" />
			<path d="m177.218 54.504-12.971 31.454 24.9-14.7V54.504Z" />
			<path d="M120.558 54.504h-11.933v16.757l24.888 14.7Z" />
			<path d="M108.625 42.172h6.837l-6.837-16.6Z" />
		</g>
		<path
			d="M0 51.262V25.671h12.827v25.335c0 6.581 3.323 9.712 8.4 9.712s8.4-3 8.4-9.377v-25.67h12.832v25.271c0 14.728-8.4 21.166-21.374 21.166S0 65.527 0 51.262Z"
			fill="currentColor"
		/>
		<path
			d="M54.792 25.671h12.636v16.5h16.213v-16.5h12.636v45.59H83.641V54.505H67.444v16.756H54.792Z"
			fill="currentColor"
		/>
		<path
			d="M201.467 25.671h17.588c16.278 0 25.735 9.377 25.735 22.54v.128c0 13.163-9.569 22.923-25.99 22.923h-17.333Zm17.8 34.393c7.556 0 12.572-4.169 12.572-11.533v-.128c0-7.3-5.016-11.533-12.572-11.533h-5.144v23.194Z"
			fill="currentColor"
		/>
	</svg>
);

export default Logo;
